module.exports = __webpack_public_path__ + "img/line_yaw.313d4b17.png";